export const OPERATOR_AND = 'AND';
export const OPERATOR_OR = 'OR';
export const OPERATOR_EQUAL = '=';
export const OPERATOR_LESSTHAN_EQUAL = '<=';
export const OPERATOR_GREATERTHAN_EQUAL = '>=';
export const OPERATOR_IN = 'in';
export const OPERATOR_NULL = 'null';
export const OPERATOR_LIKE_CASEINSENSITIVE = 'ilike';
export const OPERATOR_IN_ARRAY = '@>';

// Entity names for redux store and other uses.
// Must correspond to the entity names in backend/db/constants.DB_ENTITY_XXX
export const ENTITY_NAME_ANSWER = 'Answer'
export const ENTITY_NAME_ARTICLE = 'Article'
export const ENTITY_NAME_ARTICLE_TYPE = 'ArticleType'
export const ENTITY_NAME_ASSET = 'Asset'
export const ENTITY_NAME_BRAND_VOICE = 'BrandVoice'
export const ENTITY_NAME_CAMPAIGN = 'Campaign'
export const ENTITY_NAME_COMPANY = 'Company'
export const ENTITY_NAME_COMPANY_TYPE = 'CompanyType'
export const ENTITY_NAME_COMPANY_SUB_TYPE = 'CompanySubType'
export const ENTITY_NAME_CONTENT = 'Content'
const ENTITY_NAME_COUNTRY = 'Country'
export const ENTITY_NAME_FIRM = 'Firm'
const ENTITY_NAME_FIRM_CONTACT = 'FirmContact'
const ENTITY_NAME_FIRM_LEDGER = 'FirmLedger'
const ENTITY_NAME_FIRM_NOTE = 'FirmNote'
export const ENTITY_NAME_GUIDELINES = 'Guidelines'
export const ENTITY_NAME_KNOWLEDGE_BASE = 'KnowledgeBase'
export const ENTITY_NAME_LANGUAGE = 'Language'
export const ENTITY_NAME_LINK = 'Link'
const ENTITY_NAME_MASTER_TOPIC = 'MasterTopic'
export const ENTITY_NAME_PERSONA = 'Persona'
export const ENTITY_NAME_PRODUCT = 'Product'
export const ENTITY_NAME_PRODUCT_TYPE = 'ProductType'
export const ENTITY_NAME_PUBLISH = 'Publish'
export const ENTITY_NAME_SOURCE_CONTENT = 'SourceContent'
const ENTITY_NAME_STATE = 'State'
const ENTITY_NAME_SUBSCRIPTION = 'Subscription'
export const ENTITY_NAME_TESTIMONIAL = 'Testimonial'
export const ENTITY_NAME_TOPIC = 'Topic'
export const ENTITY_NAME_WRITING_STYLE = 'WritingStyle'
export const ENTITY_NAME_WRITING_STYLE_TYPE = 'WritingStyleType'
export const ENTITY_NAME_USER = 'User'
export const ENTITY_NAME_ROLE = 'Role'
export const ENTITY_NAME_PERMISSION = 'Permission'
export const ENTITY_NAME_CONTENT_TYPE = 'ContentType'
export const ENTITY_NAME_CONTENT_OPTIMIZED = "Optimized"
export const ENTITY_NAME_CONTENT_GENERATED = "Generated"
export const ENTITY_NAME_SOURCE_CONTENT_GENERATED = "Generated"
export const ENTITY_NAME_SOURCE_CONTENT_OPTIMIZED = "Optimized"

export const ENTITY_NAME_BACK_OFFICE_FIRM = 'BackOfficeFirm'
export const ENTITY_NAME_BACK_OFFICE_FIRM_STATUS = 'BackOfficeFirmStatus'
export const ENTITY_NAME_BACK_OFFICE_BILLING_METRICS = 'BackOfficeBillingMetrics'
export const ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_FIRM_NAME = 'BackOfficeBillingMetricsFirmName'
export const ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_USER_NAME = 'BackOfficeBillingMetricsUserName'
export const ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_SCREEN = 'BackOfficeBillingMetricsScreen'
export const ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_OPERATION = 'BackOfficeBillingMetricsOperation'
export const ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE = 'BackOfficePromptTemplate'
export const ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK = 'BackOfficeInstructionBlock'
export const ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST = 'BackOfficeSupportRequest'
const ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST_STATUS = 'BackOfficeSupportRequestStatus'
export const ENTITY_NAME_BACK_OFFICE_USER = 'BackOfficeBackofficeUser'
export const ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR = 'BackOfficeContentValidator';

export const ARTICLE_TYPE_FILE = 'FILE';
export const ARTICLE_TYPE_LINK = 'LINK';
export const ARTICLE_TYPE_YOUTUBE = 'YOUTUBE';
export const ARTICLE_TYPE_GOOGLE = 'GOOGLE';
export const ARTICLE_TYPE_TRIPADVISOR = 'TRIPADVISOR';

export const WRITING_STYLE_TYPE_LINK = 'LINK';
export const WRITING_STYLE_TYPE_FILE = 'FILE';

export const entityNames = [
    ENTITY_NAME_ARTICLE,
    ENTITY_NAME_ASSET,
    ENTITY_NAME_BRAND_VOICE,
    ENTITY_NAME_CAMPAIGN,
    ENTITY_NAME_COMPANY,
    ENTITY_NAME_COMPANY_TYPE,
    ENTITY_NAME_COMPANY_SUB_TYPE,
    ENTITY_NAME_CONTENT,
    ENTITY_NAME_FIRM,
    ENTITY_NAME_FIRM_CONTACT,
    ENTITY_NAME_FIRM_LEDGER,
    ENTITY_NAME_FIRM_NOTE,
    ENTITY_NAME_KNOWLEDGE_BASE,
    ENTITY_NAME_MASTER_TOPIC,
    ENTITY_NAME_PERSONA,
    ENTITY_NAME_PRODUCT,
    ENTITY_NAME_PUBLISH,
    ENTITY_NAME_ROLE,
    ENTITY_NAME_SOURCE_CONTENT,
    ENTITY_NAME_SUBSCRIPTION,
    ENTITY_NAME_TOPIC,
    ENTITY_NAME_USER,
    ENTITY_NAME_WRITING_STYLE,

    ENTITY_NAME_BACK_OFFICE_FIRM,
    ENTITY_NAME_BACK_OFFICE_BILLING_METRICS,
    ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE,
    ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK,
    ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST,
    ENTITY_NAME_BACK_OFFICE_USER,
]

export const entityInfo = {
  [ENTITY_NAME_ARTICLE]: {labelColumn: 'name', alias: ENTITY_NAME_ARTICLE, parentAlias: {[ENTITY_NAME_KNOWLEDGE_BASE]: 'knowledgeBase', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_ARTICLE_TYPE]: {labelColumn: 'label'},
  [ENTITY_NAME_ASSET]: {labelColumn: 'name', alias: ENTITY_NAME_ASSET, parentAlias: {}},
  [ENTITY_NAME_BRAND_VOICE]: {labelColumn: 'name', alias: ENTITY_NAME_BRAND_VOICE, parentAlias: {[ENTITY_NAME_KNOWLEDGE_BASE]: 'knowledgeBase', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_CAMPAIGN]: {labelColumn: 'name', alias: ENTITY_NAME_CAMPAIGN, parentAlias: {[ENTITY_NAME_COMPANY]: 'company', [ENTITY_NAME_PRODUCT]: 'product', [ENTITY_NAME_PERSONA]: 'persona', [ENTITY_NAME_WRITING_STYLE]: 'writingStyle', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_COMPANY]: {labelColumn: 'name', alias: ENTITY_NAME_COMPANY, parentAlias: {[ENTITY_NAME_BRAND_VOICE]: 'brandVoice', [ENTITY_NAME_WRITING_STYLE]: 'writingStyle', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_COMPANY_TYPE]: {labelColumn: 'name'},
  [ENTITY_NAME_COMPANY_SUB_TYPE]: {labelColumn: 'name'},
  [ENTITY_NAME_CONTENT]: {labelColumn: 'title', alias: ENTITY_NAME_CONTENT, parentAlias: {[ENTITY_NAME_COMPANY]: 'company', [ENTITY_NAME_PRODUCT]: 'product', [ENTITY_NAME_CAMPAIGN]: 'campaign', [ENTITY_NAME_SOURCE_CONTENT]: 'sourceContent', [ENTITY_NAME_WRITING_STYLE]: 'writingStyle', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_CONTENT_TYPE]: {labelColumn: 'name'},
  [ENTITY_NAME_COUNTRY]: {labelColumn: 'name'},
  [ENTITY_NAME_FIRM]: {labelColumn: 'name', alias: ENTITY_NAME_FIRM, parentAlias: {}},
  [ENTITY_NAME_FIRM_CONTACT]: {labelColumn: 'name', alias: ENTITY_NAME_FIRM_CONTACT, parentAlias: {[ENTITY_NAME_FIRM]: 'firm', [ENTITY_NAME_COUNTRY]: 'country', [ENTITY_NAME_STATE]: 'state', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_KNOWLEDGE_BASE]: {labelColumn: 'name', alias: ENTITY_NAME_KNOWLEDGE_BASE, parentAlias: {[ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_LANGUAGE]: {labelColumn: 'label'},
  [ENTITY_NAME_LINK]: {labelColumn: 'title', alias: ENTITY_NAME_LINK, parentAlias: {[ENTITY_NAME_ASSET]: 'asset'}},
  [ENTITY_NAME_PERMISSION]: {labelColumn: 'name', alias: ENTITY_NAME_PERMISSION},
  [ENTITY_NAME_PERSONA]: {labelColumn: 'name', alias: ENTITY_NAME_PERSONA, [ENTITY_NAME_USER]: 'createdBy'},
  [ENTITY_NAME_PRODUCT]: {labelColumn: 'name', alias: ENTITY_NAME_PRODUCT, parentAlias: {[ENTITY_NAME_COMPANY]: 'company', [ENTITY_NAME_WRITING_STYLE]: 'writingStyle', [ENTITY_NAME_PERSONA]: 'persona', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_PRODUCT_TYPE]: {labelColumn: 'name'},
  [ENTITY_NAME_PUBLISH]: {labelColumn: 'title', alias: ENTITY_NAME_PUBLISH, parentAlias: {[ENTITY_NAME_CONTENT]: 'content', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_ROLE]: {labelColumn: 'name', alias: ENTITY_NAME_ROLE, parentAlias: {}},
  [ENTITY_NAME_SOURCE_CONTENT]: {labelColumn: 'name', alias: ENTITY_NAME_SOURCE_CONTENT, parentAlias: {[ENTITY_NAME_COMPANY]: 'company', [ENTITY_NAME_PRODUCT]: 'product', [ENTITY_NAME_CAMPAIGN]: 'campaign', [ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_TOPIC]: {labelColumn: 'name'},
  [ENTITY_NAME_WRITING_STYLE]: {labelColumn: 'name', alias: ENTITY_NAME_WRITING_STYLE, parentAlias: {[ENTITY_NAME_USER]: 'createdBy'}},
  [ENTITY_NAME_WRITING_STYLE_TYPE]: {labelColumn: 'name'},

  [ENTITY_NAME_BACK_OFFICE_FIRM]: {labelColumn: 'name', alias: ENTITY_NAME_FIRM, parentAlias: {}},
  [ENTITY_NAME_BACK_OFFICE_FIRM_STATUS]: {labelColumn: 'name'},
  [ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_FIRM_NAME]: {labelColumn: 'name'},
  [ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_USER_NAME]: {labelColumn: 'firstName'},
  [ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_SCREEN]: {labelColumn: 'name'},
  [ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_OPERATION]: {labelColumn: 'name'},
  [ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: {labelColumn: 'name'},
  [ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: {labelColumn: 'name'},
  [ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: { labelColumn: 'triggerQuestion' },
  [ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST_STATUS]: { labelColumn: 'name' },
  [ENTITY_NAME_BACK_OFFICE_USER]: { labelColumn: 'firstName' },
}

export const PERMISSION_PREFIX_CREATE = 'Create'
export const PERMISSION_PREFIX_UPDATE = 'Update'
export const PERMISSION_PREFIX_READ = 'Read'
export const PERMISSION_PREFIX_DELETE = 'Delete'

// firm admin permissions
export const PERMISSION_FIRM_UPDATE = 'UpdateFirm'
export const PERMISSION_FIRM_READ = 'ReadFirm'
export const PERMISSION_USER_CREATE = 'CreateUser'
export const PERMISSION_USER_UPDATE = 'UpdateUser'
export const PERMISSION_USER_DELETE = 'DeleteUser'
export const PERMISSION_USER_READ = 'ReadUser'
export const PERMISSION_USER_PERMISSION_CREATE = 'CreateUserPermission'
export const PERMISSION_USER_PERMISSION_UPDATE = 'UpdateUserPermission'
export const PERMISSION_USER_PERMISSION_DELETE = 'DeleteUserPermission'
export const PERMISSION_USER_PERMISSION_READ = 'ReadUserPermission'
export const PERMISSION_FIRM_CONTACT_CREATE = 'CreateFirmContact'
export const PERMISSION_FIRM_CONTACT_UPDATE = 'UpdateFirmContact'
export const PERMISSION_FIRM_CONTACT_READ = 'ReadFirmContact'
export const PERMISSION_FIRM_CONTACT_DELETE = 'DeleteFirmContact'
export const PERMISSION_FIRM_LEDGER_CREATE = 'CreateFirmLedger'
export const PERMISSION_FIRM_LEDGER_UPDATE = 'UpdateFirmLedger'
export const PERMISSION_FIRM_LEDGER_READ = 'ReadFirmLedger'
export const PERMISSION_FIRM_LEDGER_DELETE = 'DeleteFirmLedger'
export const PERMISSION_FIRM_NOTE_CREATE = 'CreateFirmNote'
export const PERMISSION_FIRM_NOTE_UPDATE = 'UpdateFirmNote'
export const PERMISSION_FIRM_NOTE_READ = 'ReadFirmNote'
export const PERMISSION_FIRM_NOTE_DELETE = 'DeleteFirmNote'
export const PERMISSION_TOPIC_CREATE = 'CreateTopic'
export const PERMISSION_TOPIC_UPDATE = 'UpdateTopic'
export const PERMISSION_TOPIC_READ = 'ReadTopic'
export const PERMISSION_TOPIC_DELETE = 'DeleteTopic'
export const PERMISSION_SUBSCRIPTION_READ = 'ReadSubscription'

// firm user permissions
export const PERMISSION_ARTICLE_CREATE = 'CreateArticle'
export const PERMISSION_ARTICLE_UPDATE = 'UpdateArticle'
export const PERMISSION_ARTICLE_READ = 'ReadArticle'
export const PERMISSION_ARTICLE_DELETE = 'DeleteArticle'
export const PERMISSION_BRAND_VOICE_CREATE = 'CreateBrandVoice'
export const PERMISSION_BRAND_VOICE_UPDATE = 'UpdateBrandVoice'
export const PERMISSION_BRAND_VOICE_READ = 'ReadBrandVoice'
export const PERMISSION_BRAND_VOICE_DELETE = 'DeleteBrandVoice'
export const PERMISSION_CAMPAIGN_CREATE = 'CreateCampaign'
export const PERMISSION_CAMPAIGN_UPDATE = 'UpdateCampaign'
export const PERMISSION_CAMPAIGN_READ = 'ReadCampaign'
export const PERMISSION_CAMPAIGN_DELETE = 'DeleteCampaign'
export const PERMISSION_COMPANY_CREATE = 'CreateCompany'
export const PERMISSION_COMPANY_UPDATE = 'UpdateCompany'
export const PERMISSION_COMPANY_READ = 'ReadCompany'
export const PERMISSION_COMPANY_DELETE = 'DeleteCompany'
export const PERMISSION_CONTENT_CREATE = 'CreateContent'
export const PERMISSION_CONTENT_UPDATE = 'UpdateContent'
export const PERMISSION_CONTENT_READ = 'ReadContent'
export const PERMISSION_CONTENT_DELETE = 'DeleteContent'
export const PERMISSION_DASHBOARD_READ = 'ReadDashboard'
export const PERMISSION_KNOWLEDGE_BASE_CREATE = 'CreateKnowledgeBase'
export const PERMISSION_KNOWLEDGE_BASE_UPDATE = 'UpdateKnowledgeBase'
export const PERMISSION_KNOWLEDGE_BASE_READ = 'ReadKnowledgeBase'
export const PERMISSION_KNOWLEDGE_BASE_DELETE = 'DeleteKnowledgeBase'
export const PERMISSION_PERSONA_CREATE = 'CreatePersona'
export const PERMISSION_PERSONA_UPDATE = 'UpdatePersona'
export const PERMISSION_PERSONA_READ = 'ReadPersona'
export const PERMISSION_PERSONA_DELETE = 'DeletePersona'
export const PERMISSION_PRODUCT_CREATE = 'CreateProduct'
export const PERMISSION_PRODUCT_UPDATE = 'UpdateProduct'
export const PERMISSION_PRODUCT_READ = 'ReadProduct'
export const PERMISSION_PRODUCT_DELETE = 'DeleteProduct'
export const PERMISSION_MEDIA_CREATE = 'CreateMedia'
export const PERMISSION_MEDIA_UPDATE = 'UpdateMedia'
export const PERMISSION_MEDIA_READ = 'ReadMedia'
export const PERMISSION_MEDIA_DELETE = 'DeleteMedia'
export const PERMISSION_ASSET_CREATE = 'CreateAsset'
export const PERMISSION_ASSET_UPDATE = 'UpdateAsset'
export const PERMISSION_ASSET_READ = 'ReadAsset'
export const PERMISSION_ASSET_DELETE = 'DeleteAsset'
export const PERMISSION_LINK_CREATE = 'CreateLink'
export const PERMISSION_LINK_UPDATE = 'UpdateLink'
export const PERMISSION_LINK_READ = 'ReadLink'
export const PERMISSION_LINK_DELETE = 'DeleteLink'
export const PERMISSION_PUBLISH_CREATE = 'CreatePublish'
export const PERMISSION_PUBLISH_UPDATE = 'UpdatePublish'
export const PERMISSION_PUBLISH_READ = 'ReadPublish'
export const PERMISSION_PUBLISH_DELETE = 'DeletePublish'
export const PERMISSION_SCHEDULE_CREATE = 'CreateSchedule'
export const PERMISSION_UNSCHEDULE_DELETE = 'DeleteUnschedule'
export const PERMISSION_ROLE_CREATE = 'CreateRole'
export const PERMISSION_ROLE_DELETE = 'DeleteRole'
export const PERMISSION_ROLE_READ = 'ReadRole'
export const PERMISSION_ROLE_UPDATE = 'UpdateRole'
export const PERMISSION_SOURCE_CONTENT_CREATE = 'CreateSourceContent'
export const PERMISSION_SOURCE_CONTENT_UPDATE = 'UpdateSourceContent'
export const PERMISSION_SOURCE_CONTENT_READ = 'ReadSourceContent'
export const PERMISSION_SOURCE_CONTENT_DELETE = 'DeleteSourceContent'
export const PERMISSION_WRITING_STYLE_CREATE = 'CreateWritingStyle'
export const PERMISSION_WRITING_STYLE_UPDATE = 'UpdateWritingStyle'
export const PERMISSION_WRITING_STYLE_READ = 'ReadWritingStyle'
export const PERMISSION_WRITING_STYLE_DELETE = 'DeleteWritingStyle'
export const PERMISSION_USER_PROFILE_READ = 'ReadUserProfile'

// back office user permissions
export const PERMISSION_BACK_OFFICE_DASHBOARD_READ = 'ReadBackOfficeDashboard'